import React, { useState, useEffect } from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import '../../sass/components/flexibleModules/_components.halfHalfAccordionSection.scss';

const HalfHalfSectionWithAccordion = ({ data, indItem }) => {

    let images = [];
    let imagesColor = [];

    {
        data.halfAndHalfSectionWithAccordionRepeater &&
            <>
                {data.halfAndHalfSectionWithAccordionRepeater.map((checkAccordion, index) => (
                    <React.Fragment key={index}>
                        {images.push(checkAccordion.image)}
                        {imagesColor.push(checkAccordion.imageBackgroundColor)}
                    </React.Fragment>
                ))}
            </>
    }

    const [image, setImage] = useState(images[0]);
    const [imageBackground, setImageBackground] = useState(imagesColor[0]);
    const [activeElement, setActiveElement] = useState("elem-0");
    const [activeElementClick, setActiveElementClick] = useState(0);

    const updateImage = (val) => {
        setImage(images[val]);
        setImageBackground(imagesColor[val]);
        let update = "elem-" + val;
        setActiveElement(update);
        setTimeout(() => {
            setActiveElementClick(val);
            // let elem = `.cp-halfaHalfSectionWithAccordion__right-accordion.elem-${val}`;
            // window.scrollTo({
            //     top: document.querySelector(elem).offsetTop - 300,
            //     left: 0,
            //     behavior: "smooth",
            // });
        }, 20);
    }

    const [videoShow, setVideoShow] = useState(false);
    const showVideo = (val) => {
        setVideoShow(val);
    }

    useEffect(() => {
        if (data.halfAndHalfSectionWithAccordionHeader === 'How Planful Predict Helps You') {
            var scriptOne = document.createElement('script');
            scriptOne.src = '//fast.wistia.com/embed/medias/vvuoe0gio0.jsonp';
            scriptOne.async = 'async';
            document.getElementsByTagName('head')[0].appendChild(scriptOne);
            var scriptTwo = document.createElement('script');
            scriptTwo.src = '//fast.wistia.com/assets/external/E-v1.js';
            scriptTwo.async = 'async';
            document.getElementsByTagName('head')[0].appendChild(scriptTwo);
        }
    }, []);

    return (
        <div className={`cp-halfaHalfSectionWithAccordion ${data.halfAndHalfSectionWithAccordionLayoutSelection}`} style={{ backgroundColor: `${data.backgroundColor}` }}>
            {data.halfAndHalfSectionWithAccordionLayoutSelection === 'layout2' &&
                <div className="cp-halfaHalfSectionWithAccordion__introLayout">
                    {data.halfAndHalfSectionWithAccordionHeader &&
                        <h2>{data.halfAndHalfSectionWithAccordionHeader}</h2>
                    }
                    {data.halfAndHalfSectionWithAccordionTeaser &&
                        <p>{data.halfAndHalfSectionWithAccordionTeaser}</p>
                    }
                    {data.halfAndHalfSectionWithAccordionHeader === 'How Planful Predict Helps You' &&
                        <div class="l-relativeButton" onClick={() => showVideo(true)}>
                            <button class="l-button">Watch Overview Video</button>
                            <button class="l-button l-backgroundHover">Watch Overview Video</button>
                        </div>
                    }
                </div>
            }
            <div className="cp-halfaHalfSectionWithAccordion__inner l--flex" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth/16+"rem") : ""}`, margin: "0 auto" }}>
                <div className="cp-halfaHalfSectionWithAccordion__left">
                    {
                        imageBackground ?
                            <>
                                <div className={`l-imageWithBackground l--clickedElem${activeElementClick}`} style={{ backgroundColor: `${imageBackground}` }}>
                                    {images[0] &&
                                        <GatsbyImage className={`${activeElementClick === 0 ? "l--clickedElemChild0" : ""}`} image={getImage(images[0].gatsbyImage)} alt={images[0].altText} />
                                    }
                                    {images[1] &&
                                        <GatsbyImage className={`${activeElementClick === 1 ? "l--clickedElemChild1" : ""}`} image={getImage(images[1].gatsbyImage)} alt={images[1].altText} />
                                    }
                                    {images[2] &&
                                        <GatsbyImage className={`${activeElementClick === 2 ? "l--clickedElemChild2" : ""}`} image={getImage(images[2].gatsbyImage)} alt={images[2].altText} />
                                    }
                                    {data.halfAndHalfSectionWithAccordionLayoutSelection === 'layout2' &&
                                        <>
                                            {data.halfAndHalfSectionWithAccordionRepeater.length > 3 &&
                                                <>
                                                    {images[3] &&
                                                        <GatsbyImage className={`${activeElementClick === 3 ? "l--clickedElemChild3" : ""}`} image={getImage(images[3].gatsbyImage)} alt={images[3].altText} />
                                                    }
                                                </>
                                            }
                                            {data.halfAndHalfSectionWithAccordionRepeater.length > 4 &&
                                                <>
                                                    {images[4] &&
                                                        <GatsbyImage className={`${activeElementClick === 4 ? "l--clickedElemChild4" : ""}`} image={getImage(images[4].gatsbyImage)} alt={images[4].altText} />
                                                    }
                                                </>
                                            }
                                            {data.halfAndHalfSectionWithAccordionRepeater.length > 5 &&
                                                <>
                                                    {images[5] &&
                                                        <GatsbyImage className={`${activeElementClick === 5 ? "l--clickedElemChild5" : ""}`} image={getImage(images[5].gatsbyImage)} alt={images[5].altText} />
                                                    }
                                                </>
                                            }
                                            {data.halfAndHalfSectionWithAccordionRepeater.length > 6 &&
                                                <>
                                                    {images[6] &&
                                                        <GatsbyImage className={`${activeElementClick === 6 ? "l--clickedElemChild6" : ""}`} image={getImage(images[6].gatsbyImage)} alt={images[6].altText} />
                                                    }
                                                </>
                                            }
                                            {data.halfAndHalfSectionWithAccordionRepeater.length > 7 &&
                                                <>
                                                    {images[7] &&
                                                        <GatsbyImage className={`${activeElementClick === 7 ? "l--clickedElemChild7" : ""}`} image={getImage(images[7].gatsbyImage)} alt={images[7].altText} />
                                                    }
                                                </>
                                            }
                                        </>
                                    }
                                </div>
                            </>
                            :
                            <>
                                {image &&
                                    <GatsbyImage image={getImage(image.gatsbyImage)} alt={image.altText} />
                                }
                            </>
                    }
                </div>
                <div className="cp-halfaHalfSectionWithAccordion__right">
                    {data.halfAndHalfSectionWithAccordionLayoutSelection === 'layout1' &&
                        <>
                            {data.halfAndHalfSectionWithAccordionHeader &&
                                <h2>{data.halfAndHalfSectionWithAccordionHeader}</h2>
                            }
                            {data.halfAndHalfSectionWithAccordionTeaser &&
                                <p>{data.halfAndHalfSectionWithAccordionTeaser}</p>
                            }
                        </>
                    }
                    {data.halfAndHalfSectionWithAccordionRepeater &&
                        <>
                            {data.halfAndHalfSectionWithAccordionRepeater.map((checkAccordion, index) => (
                                <div className={`cp-halfaHalfSectionWithAccordion__right-accordion elem-${index} ${activeElement === `elem-${index}` ? 'is-active' : 'inactive'}`} key={index}>
                                    {checkAccordion.header &&
                                        <button onClick={() => updateImage(index)}>{checkAccordion.header}</button>
                                    }
                                    <div className="l--accordionHidden">
                                        {checkAccordion.teaser &&
                                            <p dangerouslySetInnerHTML={{__html: checkAccordion.teaser}} />
                                        }
                                        {checkAccordion.link &&
                                            <a href={checkAccordion.link.url} target={checkAccordion.link.target} className="l--textLink">
                                                <span>{checkAccordion.link.title}</span>
                                                <StaticImage src="../../images/arrow-pro-right.svg" alt="" />
                                            </a>
                                        }
                                    </div>
                                    {
                                        checkAccordion.imageBackgroundColor ?
                                            <div className="l-imageWithBackground l--mobileOnly" style={{ backgroundColor: `${checkAccordion.imageBackgroundColor}` }}>
                                                {checkAccordion.image &&
                                                    <GatsbyImage image={getImage(checkAccordion.image.gatsbyImage)} alt={checkAccordion.image.altText} />
                                                }
                                            </div>
                                            :
                                            <>
                                                {checkAccordion.image &&
                                                    <GatsbyImage image={getImage(checkAccordion.image.gatsbyImage)} alt={checkAccordion.image.altText} />
                                                }
                                            </>
                                    }
                                </div>
                            ))}
                        </>
                    }
                </div>
                {videoShow &&
                    <div className="cp-postPerformEventIntro__formVideo l--flex l--abtestOverride">
                        <div className="cp-postPerformEventIntro__formVideo-left" id="l-leftForm">
                            <div className="l-modalVideo">
                                <div className={`wistia_embed wistia_async_vvuoe0gio0 autoPlay=true`}>&nbsp;</div>
                            </div>
                            <button onClick={() => showVideo(false)} className="l-backgroundTrigger"></button>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

export default HalfHalfSectionWithAccordion;